import { DateTime } from 'luxon';
import { EmployeeDTO, EmployeeDTOStatusEnum, UserDTOStatusEnum } from 'probonio-shared-ui/api';
import { StatusColor } from '../types/statusColors';

type CombinedEmployeeStatus =
  | UserDTOStatusEnum
  | EmployeeDTOStatusEnum
  | 'PENDING'
  | 'CREATED'
  | 'EXPIRED'
  | 'MAIL_DELIVERY_ERROR'
  | 'PLANNED_TERMINATION'
  | 'INVITATION_CODE';

export function mapEmployeeStatus(employee: EmployeeDTO): {
  status: CombinedEmployeeStatus;
  color: StatusColor;
  scheduledInviteDate?: string;
  inviteWhenActive?: boolean;
} {
  const inviteWhenActive = employee.nextGift?.inviteWhenActive;
  const scheduledInviteDate = employee.nextGift?.payoutDate;

  let status: CombinedEmployeeStatus = employee.status;
  let color: StatusColor = 'success';
  if (!employee.user && employee.expiryDateRegistrationCode && DateTime.fromISO(employee.expiryDateRegistrationCode) <= DateTime.utc()) {
    status = 'EXPIRED';
    color = 'error';
  } else if (employee.status === 'INACTIVE') {
    color = 'default';
  } else if (!employee.user && employee.mailDeliveryError) {
    status = 'MAIL_DELIVERY_ERROR';
    color = 'error';
  } else if (!employee.user && employee.status === 'ACTIVE' && employee.invitationMailSentAt && !employee.terminationDate) {
    status = 'PENDING';
    color = 'info';
  } else if (!employee.user && !employee.mail && employee.registrationCode) {
    status = 'INVITATION_CODE';
    color = 'warning';
  } else if (!employee.user && !employee.invitationMailSentAt) {
    status = 'CREATED';
    color = 'warning';
  } else if (employee.status === 'ACTIVE' && employee.terminationDate) {
    status = 'PLANNED_TERMINATION';
    color = 'warning';
  } else if (employee.status === 'REGISTERED') {
    color = 'warning';
  }
  return { status, color, scheduledInviteDate, inviteWhenActive };
}
